export const MEDIAS_CLASSNAMES = {
  GESTURE: 'hasGesture',
  ZOOMED: 'zoomed',
  OPENED: 'opened',
  ACTIVE: `active`,
  DISABLED: `disabled`,
};
